import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { ClientArea } from '../pages/ClienteArea';
import { PlanDetails } from 'pages/PlanDetails/';
import { KenloLocation } from 'pages/kenloLocation';
import HistoryOfInvoices from 'pages/HistoryOfInvoices';
import { ChangeOfPlan } from 'pages/ChangeOfPlan';
import { RenewPlan } from 'pages/RenewPlan';
import { SignIn } from 'pages/SignIn';
import { ForgotPassword } from 'pages/ForgotPassword';
import { QualifierDetails } from 'pages/QualifierDetails';
import { KenloSignature } from 'pages/KenloSignature';
import { LIA } from 'pages/LYA';

import { ForgotPasswordCod } from 'pages/ForgotPasswordCod';
import { NewPassword } from 'pages/NewPassword';
import { KenloIntelligence } from 'pages/KenloIntelligence';
// import { BuyPackage } from '../pages/BuyPackage';
import { Auth } from 'pages/Auth';
// import { FreshDeskLoader } from 'components/FreshDesk/FreshDesk';

export const Routes = () => (
  <Router>
    {/* <FreshDeskLoader /> */}
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/Forgot-password" exact component={ForgotPassword} />
      <Route path="/ClientArea" component={ClientArea} />
      <Route path="/PlanDetails/:id" component={PlanDetails} />
      <Route path="/KenloLocation/:id" component={KenloLocation} />
      <Route path="/KenloIntelligence" component={KenloIntelligence} />

      <Route path="/HistoryOfInvoices/:id" component={HistoryOfInvoices} />
      <Route path="/ChangeOfPlan/:id" component={ChangeOfPlan} />
      <Route path="/RenewPlan/:id" component={RenewPlan} />
      <Route path="/QualifierDetails/:id/:type" component={QualifierDetails} />
      <Route path="/KenloSignature/:id/:type" component={KenloSignature} />
      <Route path="/LYA/:id/:type" component={LIA} />
      <Route path="/Forgot-password-cod" component={ForgotPasswordCod} />
      <Route path="/New-password" component={NewPassword} />
      {/* <Route path="/Buy-package/:id/:type" component={BuyPackage} /> */}
      <Route path="/Auth" component={Auth} />
    </Switch>
  </Router>
);
